import React, { type ReactNode } from "react";
import { Image, View } from "tamagui";
import { Label } from "./Label";

export const Expander: React.FC<{ children: ReactNode; maxHeight: number }> = ({
  maxHeight,
  children,
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const [contentHeight, setContentHeight] = React.useState(0);
  const showToggle = contentHeight > maxHeight && !expanded;
  return (
    <View maxHeight={expanded ? undefined : maxHeight} overflow="hidden">
      <View
        position="absolute"
        top={0}
        right={0}
        left={0}
        zIndex={10}
        onLayout={(e) => {
          const { height } = e.nativeEvent.layout;
          setContentHeight(height);
        }}
      >
        {children}
      </View>

      <View height={contentHeight} />

      {showToggle && (
        <View
          position="absolute"
          bottom={0}
          height={96}
          right={0}
          left={0}
          zIndex={15}
          onPress={() => {
            setExpanded(!expanded);
          }}
          cursor="pointer"
        >
          <Label
            textAlign="center"
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            zIndex={5}
          >
            Show more
          </Label>
          <Image
            position="absolute"
            bottom={0}
            width="100%"
            resizeMode="repeat"
            height={48}
            source={require("../../assets/fade_white.png")}
          />
        </View>
      )}
    </View>
  );
};
